<template>
  <m-pay-generic-editor
    :loading="loading"
    :bean="newUser"
    :beanPropertyValues="beanPropertyValues"
    :beanProperties="editableProperties"
    :validationRules="editableRules"
    @cancel="cancel"
    @submit="submit"
  />
</template>

<script>

import roles from '../../utils/user-roles';
import MPayGenericEditor from '../MPayGenericEditor';

export default {

  name: 'MPayMerchantEmployeeEditor',

  props: ['user', 'loading'],

  components: { MPayGenericEditor },

  data: () => ({
    newUser: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      userRole: roles.ROLE_MERCHANT_OPERATOR.id,
    },
    editableProperties: [
      'firstName',
      'lastName',
      'email',
      'phoneNumber',
      'position',
      'description',
      'userRole',
    ],
    editableRules: [
      'required|max:25',
      'required|max:25',
      'required|email|max:50',
      'required|max:20',
      'max:100',
      'max:255',
      'required',
    ],
  }),

  computed: {
    merchantId() {
      return this.$route.query.merchant;
    },
    beanPropertyValues() {
      return {
        userRole: [
          roles.ROLE_MERCHANT_ADMIN.id,
          roles.ROLE_MERCHANT_OPERATOR.id,
        ],
      };
    },
  },

  methods: {
    submit(bean) {
      const model = Object.assign({}, bean);
      model.merchantId = this.merchantId;
      this.$emit('submit', model);
    },
    cancel() {
      this.$emit('cancel');
    },
  },

};
</script>




// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantEmployeeEditor.vue